export const VAULTS_FILTERS_STORAGE_KEY = 'yearn.fi/vaults-filters@1'

export function usePersistedShowHiddenVaults(): boolean {
  return false
}
